import React from 'react';

const carriesFiles = event => Array.from(event.dataTransfer.types || []).includes('Files');

export default class FileDropTarget extends React.Component {
    constructor(props) {
        super(props);

        this.state = { over: false };
        // dragenter/dragleave fire for every child crossed, so count them rather than trust one leave.
        this.depth = 0;

        this.handleDragEnter = this.handleDragEnter.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
    }

    componentDidUpdate() {
        if (!this.props.enabled && this.state.over) {
            this.depth = 0;
            this.setState({ over: false });
        }
    }

    handleDragEnter(event) {
        if (!this.props.enabled || !carriesFiles(event)) return;
        event.preventDefault();
        this.depth += 1;
        if (!this.state.over) this.setState({ over: true });
    }

    handleDragOver(event) {
        if (!this.props.enabled || !carriesFiles(event)) return;
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    }

    handleDragLeave() {
        if (!this.depth) return;
        this.depth -= 1;
        if (!this.depth) this.setState({ over: false });
    }

    handleDrop(event) {
        if (!this.props.enabled || !carriesFiles(event)) return;
        event.preventDefault();
        this.depth = 0;
        this.setState({ over: false });

        const files = Array.from(event.dataTransfer.files || []);
        if (files.length) this.props.onFiles(files);
    }

    render() {
        const child = React.Children.only(this.props.children);

        return React.cloneElement(child, {
            className: [child.props.className, this.state.over && 'drag-over'].filter(Boolean).join(' '),
            onDragEnter: this.handleDragEnter,
            onDragOver: this.handleDragOver,
            onDragLeave: this.handleDragLeave,
            onDrop: this.handleDrop,
        });
    }
}
